import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "pb-m" }

import { NResult } from 'naive-ui';
import { ref, withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    title: { default: '404 Not Found' },
    status: { default: '404' },
    description: { default: undefined },
    redirectLink: { default: '/' },
    redirectText: { default: 'Přejít na domovskou stránku' }
  },
  setup(__props: any) {

const props = __props as { title: string, status: '404' | '500' | 'error' | 'info' | 'success' | 'warning' | '403' | '418', description: string, redirectLink: string, redirectText: string }



const pageUrl = ref<string>(window.location.href);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NResult), {
      status: __props.status,
      title: __props.title,
      description: __props.description
    }, {
      footer: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, _toDisplayString(pageUrl.value), 1),
        _createVNode(_component_router_link, { to: __props.redirectLink }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.redirectText), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["status", "title", "description"])
  ]))
}
}

})